import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ILinkShieldSessionLoaded,
  IRedirectStarted,
  ITestRunned,
} from './LoadingBarActionTypes';
import {
  IAcquireTestResultsBody,
  IJwtLinkShieldSessionSchema,
} from 'appwiki-link-shield-proxy';

export enum ExecuteType {
  TIMEOUT = 'TIMEOUT',
  MOUSE_DISTANCE = 'MOUSE_DISTANCE',
  CLICK = 'CLICK',
}

export type ITestProviderLoaded<T> = { status: 'LOADED'; instance: T };
export type ITestProviderError = { status: 'ERROR'; reason: string };
export type ITestProvider<T> = ITestProviderLoaded<T> | ITestProviderError;

export type ILoadingBar = {
  testsCompleted: boolean;
  linkShieldSession?: IJwtLinkShieldSessionSchema;
  redirectUrl?: string;
  providerResults: IAcquireTestResultsBody[];
};

export const initialState: ILoadingBar = {
  testsCompleted: false,
  providerResults: [],
};

const slice = createSlice({
  name: 'Features/LoadingBar',
  initialState,
  reducers: {
    loadLinkShieldSession: (state, action: ILinkShieldSessionLoaded) => {
      state.linkShieldSession = action.payload;
    },
    testRecaptcha: (_state, _action: ITestRunned) => {},
    testCheq: (_state, _action: ITestRunned) => {},
    setTestsCompleted: (state) => {
      state.testsCompleted = true;
    },
    startRedirect: (state, action: IRedirectStarted) => {
      state.redirectUrl = action.payload.redirect;
    },
    recordProviderResultInState: (
      state,
      action: PayloadAction<IAcquireTestResultsBody>,
    ) => {
      state.providerResults.push(action.payload);
    },
  },
});

export const {
  loadLinkShieldSession,
  testRecaptcha,
  testCheq,
  setTestsCompleted,
  startRedirect,
  recordProviderResultInState,
} = slice.actions;

export const loadingBarReducer = slice.reducer;
